// extracted by mini-css-extract-plugin
export default {"header":"Nck0sh","userContent":"FkNyDL","headerContent":"zTJuoN"};